// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".displayNameWrapper .v-messages__wrapper[data-v-04a98c40]{color:var(--v-success-base)}.displayNameWrapper.errors .v-messages__wrapper[data-v-04a98c40]{color:var(--v-error-lighten1)}", ""]);
// Exports
module.exports = exports;
